import { Phone, Sparkles, Users } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const identifyFreeTrialEndingConversionCallAr: TemplateAr = {
  name: 'رصد قرب انتهاء التجربة المجانية + مكالمة تحويل',
  description:
    'الذكاء الاصطناعي يرصد مستخدمي التجربة اللي أوشكت على الانتهاء ويشغّل مكالمات تحويل مع دعم في الإعداد وعروض خاصة.',
  category: 'ذكاء الإيرادات',
  workflow: [
    { icon: Users, label: 'التجربة تقارب النهاية' },
    { icon: Sparkles, label: 'الـ AI يحلل' },
    { icon: Phone, label: 'مكالمة تحويل', final: true },
  ],
  detailDescription: {
    paragraph1:
      'قبل ما تخلص التجربة المجانية، تعرف مين جاهز للمكالمة ومين يحتاج وقتاً أكثر. الـ AI يحلل التفاعل خلال التجربة، وتبنّي المزايا، وتكرار الاستخدام، ومؤشرات إدراك القيمة. التجربة عالية التفاعل يجيها مكالمة تحويل مخصصة، وفيها دعم الإعداد وخيارات التسعير وخصم لفترة محدودة. والتجربة ضعيفة التفاعل يجيها محتوى تعليمي وجولة في المنتج أول.',
    paragraph2:
      'تتابع بيانات تحويل التجربة ونتائجها في تحليلات منتجك أو CRM أو أدوات إدارة الاشتراكات. والـ AI يجرّب استراتيجيات تحويل مختلفة — توقيت المكالمة، وحجم الخصم، ودعم الإعداد — ويحسّنها على أساس معدلات التحويل. والتحويل اللي ينجح يشغّل إعداد الفوترة ومسارات نجاح العملاء تلقائياً.',
  },
  benefits: [
    'التحويل من تجربة لمدفوع يرتفع ٤٠٪+',
    'تحوّل التجربة في وقتها الصح',
    'كل مستخدم له مسار تحويل على مقاسه',
    'التسرّب من التجربة ينزل',
    'تحصل على دعم فعلي في الإعداد والانطلاق',
    'تشوف إسناد كل تحويل بدقة',
  ],
};
